import { Component, Inject, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Cls_RegionData } from "@frontend/app/models/master";
import { MasterService } from "@frontend/app/serivces/master.service";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { ToastrService } from "@frontend/app/serivces/toastr.service";
import { SVG_ICONS } from "@frontend/app/models/icons";

@Component({
  selector: "app-add-region",
  imports: [CommonModule, SharedModule],
  templateUrl: "./add-region.component.html",
  styleUrl: "./add-region.component.scss",
})
export class AddRegionComponent implements OnInit {
  private masterService = inject(MasterService);
  private toastrService = inject(ToastrService);

  private dialogRef = inject(MatDialogRef<AddRegionComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    if (this.data?.regionId) {
      this.regionList.RegionID = this.data.regionId;
      this.getRegionDetailsByID(this.data.regionId);
    }
  }
  //#region variables
  regionList = new Cls_RegionData();
  isUserTypeDropdownOpen = false;
  ErrorMsg: string[] = [];
  readonly SVG_ICONS = SVG_ICONS;

  //#endregion

  validateForm(): boolean {
    if (!this.regionList.RegionName || !this.regionList.RegionName.trim()) {
      this.toastrService.error("Region Name is required");
      return false;
    }
    return true;
  }

  getRegionDetailsByID(id: number) {
    this.masterService.getRegionDetailsByID(id).subscribe((res: any) => {
      this.regionList = res;
    });
  }
  onSubmit() {
    if (!this.validateForm()) return;
    const tempModal = new Cls_RegionData();
    tempModal.RegionID = this.regionList.RegionID;
    tempModal.RegionName = this.regionList.RegionName;
    tempModal.IsActive = true;
    if (this.data?.regionId) {
      this.masterService.updateRegion(tempModal, this.data.regionId).subscribe((res: any) => {
        this.toastrService.success("Region updated successfully");
        this.dialogRef.close(res);
      });
    } else {
      this.masterService.addRegion(tempModal).subscribe((res: any) => {
        this.toastrService.success("Region added successfully");
        this.dialogRef.close(res);
      });
    }
  }
  onClose() {
    this.dialogRef.close();
  }
}
